import ContractsValidCollectionRequest from "../../../api/raily/contracts/valid-collection/contracts-valid-collection.request";
import ContractsValidCollectionLoadParams from "./contracts-valid-collection-params";

const create = (
  params: ContractsValidCollectionLoadParams,
): ContractsValidCollectionRequest => {
  return {
    cargoCompanyId: params.cargoCompanyUuid,
  };
};

const contractsValidCollectionParamsFactory = {
  create,
};

export default contractsValidCollectionParamsFactory;
